import { render, staticRenderFns } from "./kdxStatusText.g.vue?vue&type=template&id=2df45042&scoped=true"
import script from "./kdxStatusText.g.vue?vue&type=script&lang=js"
export * from "./kdxStatusText.g.vue?vue&type=script&lang=js"
import style0 from "./kdxStatusText.g.vue?vue&type=style&index=0&id=2df45042&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2df45042",
  null
  
)

export default component.exports